var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupplierRfqImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 26.25V32.8125H2.1875V6.5625H8.75V4.375H2.1875C1.60734 4.375 1.05094 4.60547 0.640704 5.0157C0.230468 5.42594 0 5.98234 0 6.5625V32.8125C0 33.3927 0.230468 33.9491 0.640704 34.3593C1.05094 34.7695 1.60734 35 2.1875 35H19.6875C20.2677 35 20.8241 34.7695 21.2343 34.3593C21.6445 33.9491 21.875 33.3927 21.875 32.8125V26.25H19.6875Z",
    fill: "url(#paint0_linear_421_891)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6643 13.0063L24.1877 10.3659C23.9632 10.1314 23.6615 10 23.3472 10C23.0329 10 22.7311 10.1314 22.5066 10.3659L12 21.5674V26H16.1501L26.6568 14.7985C26.8768 14.5592 27 14.2375 27 13.9024C27 13.5673 26.8768 13.2456 26.6568 13.0063H26.6643ZM15.5272 24.3998H13.5009V22.2395L20.5854 14.6785L22.6192 16.8468L15.5272 24.3998ZM23.6774 15.7186L21.6436 13.5504L23.3472 11.7341L25.3809 13.9024L23.6774 15.7186Z",
    fill: "url(#paint1_linear_421_891)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C9.925 0 7 2.925 7 6.5C7 10.075 9.925 13 13.5 13C17.075 13 20 10.075 20 6.5C20 2.925 17.075 0 13.5 0ZM12.2 9.75L8.95 6.5L9.8665 5.5835L12.2 7.9105L17.1335 2.977L18.05 3.9L12.2 9.75Z",
    fill: "url(#paint2_linear_421_891)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 20.5H14M3.5 26H17.5",
    stroke: "url(#paint3_linear_421_891)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_421_891",
    x1: 10.9375,
    y1: 4.375,
    x2: 10.9375,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_421_891",
    x1: 19.5,
    y1: 10,
    x2: 19.5,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_421_891",
    x1: 13.5,
    y1: 0,
    x2: 13.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_421_891",
    x1: 10.5,
    y1: 20.5,
    x2: 10.5,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierRfqImg);
export default __webpack_public_path__ + "static/media/supplier_RFQ_img.5294c3dd4e4677285f54f43080d8ce96.svg";
export { ForwardRef as ReactComponent };